export default __webpack_public_path__ + "static/max-fe6f77970b20302932fcc3798794842c.jpg";